import { render, staticRenderFns } from "./SCardFooter.vue?vue&type=template&id=2e3a79fd&scoped=true&"
var script = {}
import style0 from "./SCardFooter.vue?vue&type=style&index=0&id=2e3a79fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3a79fd",
  null
  
)

export default component.exports